export enum SituacaoClientePlanejamento {
  PLANEJADO = 'PLANEJADO',
  CAPTADO = 'CAPTADO',
}
